export function getTrimmedMean(data: number[], percent: number, callback?: (data: any) => void): number {
    const n: number = Math.round(data.length * percent);
    data = [...(data || [])].sort((a: number, b: number) => a - b);

    if (percent < 0 || percent >= 0.5 || n >= data.length) {
        if (typeof callback === 'function') {
            callback({ values: [], avg: null, min: null, max: null });
        }
        return null;
    }
    const values: number[] = data.slice(n, data.length - n);

    if (!values.length) {
        if (typeof callback === 'function') {
            callback({ values: [], avg: null, min: null, max: null });
        }
        return null;
    }
    const value: number = values.reduce((a: number, b: number) => a + b, 0) / values.length;

    if (typeof callback === 'function') {
        callback({ values, avg: value, min: values[0], max: values[values.length - 1] });
    }

    return value;
}

export function getMedian(data: number[]): number {
    data = data || [];

    if (!data.length) {
        return null;
    }
    const values: number[] = [...data].sort((a: number, b: number) => a - b);
    const mid: number = Math.floor(values.length / 2);

    return values.length % 2 !== 0 ? values[mid] : (values[mid - 1] + values[mid]) / 2;
}
